import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import moment from 'moment';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DataViewModule } from 'primeng/dataview';
import { DialogModule } from 'primeng/dialog';
import { FileUploadModule } from 'primeng/fileupload';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { MessagesModule } from 'primeng/messages';
import { SelectButtonModule } from 'primeng/selectbutton';
import { Table, TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { ToastModule } from 'primeng/toast';
import { ToolbarModule } from 'primeng/toolbar';
import { TooltipModule } from 'primeng/tooltip';
import { Application } from '../../../../model/Application';
import { Club } from '../../../../model/Club';
import { HttpResponse } from '../../../../model/HttpResponse';
import { QueryOptionDto } from '../../../../model/QueryOptionDto';
import { Transfer } from '../../../../model/transfer/Transfer';
import { Renewal } from '../../../../model/renewal/Renewal';
import { ApplicationService } from '../../../../services/application.service';
import { ClubService } from '../../../../services/club.service';
import { LoadingService } from '../../../../services/loading.service';
@Component({
  selector: 'app-solicitudes-table',
  standalone: true,
  imports: [
    TableModule,
    InputNumberModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    DialogModule,
    MessagesModule,
    ToastModule,
    ToolbarModule,
    FileUploadModule,
    ButtonModule,
    InputTextModule,
    ConfirmDialogModule,
    DataViewModule,
    TagModule,
    SelectButtonModule,
    TooltipModule,
    ButtonModule,
  ],
  providers: [MessageService, ConfirmationService],
  templateUrl: './solicitudes-table.component.html',
  styleUrl: './solicitudes-table.component.scss',
})
export class SolicitudesTableComponent implements OnInit {
  productDialog: boolean = false;

  @Input()
  applications!: Application[];

  transfers: Transfer[] = [];
  renewals: Renewal[] = [];

  application!: Application | null;

  selectedApplications!: Application[] | null;

  selectedTransfers!: Transfer[] | null;

  selectedRenewals!: Renewal[] | null;

  submitted: boolean = false;

  statuses!: any[];
  showApplicationTable: boolean = true;
  showTransfersTable: boolean = false;
  showRenewalsTable: boolean = false;

  viewOptions: any[] = [
    { label: 'Nuevas Solicitudes', value: 'new' },
    { label: 'Transferencias', value: 'transfers' },
    { label: 'Renovaciones', value: 'renewals' },
    { label: 'Todas las Solicitudes', value: 'all' },
  ];

  viewSelected: any = null;

  clubes: Club[] = [];
  @Output()
  reviewApplication: EventEmitter<Application> = new EventEmitter();

  @Output()
  reviewTransfer: EventEmitter<Transfer> = new EventEmitter();

  @Output()
  reviewRenewal: EventEmitter<Renewal> = new EventEmitter();

  @Output()
  editApplication: EventEmitter<Application> = new EventEmitter();

  @Output()
  stateChange: EventEmitter<{viewSelected: string, filters?: any}> = new EventEmitter();

  @Input()
  preservedViewSelected?: string;

  @Input()
  preservedFilters?: any;

  constructor(
    private applicationService: ApplicationService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private loadingServices: LoadingService,
    private clubService: ClubService
  ) {}

  ngOnInit() {
    this.statuses = [
      { label: 'INSTOCK', value: 'instock' },
      { label: 'LOWSTOCK', value: 'lowstock' },
      { label: 'OUTOFSTOCK', value: 'outofstock' },
    ];

    this.viewSelected = this.preservedViewSelected || 'new';
    this.getClubes();
    this.getDataOfView();
  }

  getClubes() {
    this.clubService.getAllClubs().subscribe((res: HttpResponse) => {
      if (res.code === 200) {
        this.clubes = res.response as Club[];
      }
    });
  }

  getClubById(idClub: string): Club | undefined {
    return this.clubes.find((club: Club) => club.id === idClub);
  }

  getDataOfView() {
    switch (this.viewSelected) {
      case 'new':
        this.getNewApplications();
        this.showApplicationTable = true;
        this.showTransfersTable = false;
        this.showRenewalsTable = false;
        break;
      case 'transfers':
        this.getTransfers();
        this.showApplicationTable = false;
        this.showTransfersTable = true;
        this.showRenewalsTable = false;
        break;
      case 'renewals':
        this.getRenewals();
        this.showApplicationTable = false;
        this.showTransfersTable = false;
        this.showRenewalsTable = true;
        break;

      default:
        this.showApplicationTable = true;
        this.showTransfersTable = false;
        this.showRenewalsTable = false;
        this.getApplications();
        break;
    }

    this.stateChange.emit({viewSelected: this.viewSelected});
  }

  getApplications() {
    this.loadingServices.showLoading();
    const queryOptions: QueryOptionDto = {
      options: {
        conditionals: [
          {
            conditionalConnector: 'AND',
            evaluatedProperty: 'process.processStage',
            logicOperator: '<>',
            parameterName: '@Queued',
            parameterValue: 'created',
          },
        ],
      },
    };
    this.applicationService
      .getMassiveApplication(queryOptions)
      .subscribe((res: HttpResponse) => {
        this.applications = res.response || [];
        this.loadingServices.hideLoading();
      });
  }

  getNewApplications() {
    this.loadingServices.showLoading();
    const queryOptions: QueryOptionDto = {
      options: {
        conditionals: [
          {
            conditionalConnector: 'AND',
            evaluatedProperty: 'process.processStage',
            logicOperator: '=',
            parameterName: '@Created',
            parameterValue: 'created',
          },
        ],
      },
    };
    this.applicationService
      .getMassiveApplication(queryOptions)
      .subscribe((res: HttpResponse) => {
        this.applications = res.response || [];
        this.loadingServices.hideLoading();
      });
  }

  getTransfers() {
    this.loadingServices.showLoading();
    const queryOptions: QueryOptionDto = {
      options: {
        conditionals: [
          {
            conditionalConnector: 'AND',
            evaluatedProperty: 'process.processStage',
            logicOperator: '<>',
            parameterName: '@Canceled',
            parameterValue: 'canceled',
          },
          {
            conditionalConnector: 'AND',
            evaluatedProperty: 'process.processStage',
            logicOperator: '<>',
            parameterName: '@Approved',
            parameterValue: 'approved',
          },
          {
            conditionalConnector: 'AND',
            evaluatedProperty: 'process.processStage',
            logicOperator: '<>',
            parameterName: '@Rejected',
            parameterValue: 'rejected',
          },
          {
            conditionalConnector: 'AND',
            evaluatedProperty: 'process.processStage',
            logicOperator: '<>',
            parameterName: '@Finished',
            parameterValue: 'finished',
          },
        ],
      },
    };
    this.applicationService
      .getTransfers(queryOptions)
      .subscribe((res: HttpResponse) => {
        this.transfers = res.response || [];
        this.loadingServices.hideLoading();
      });
  }

  getRenewals() {
    this.loadingServices.showLoading();
    const queryOptions: QueryOptionDto = {
      options: {
        conditionals: [],
      },
    };
    this.applicationService
      .getRenewals(queryOptions)
      .subscribe((res: HttpResponse) => {
        this.renewals = res.response || [];
        this.loadingServices.hideLoading();
      });
  }

  openAll() {}

  deleteSelectedProducts() {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete the selected products?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        //   this.application = this.applications.filter((val) => !this.selectedProducts?.includes(val));
        //   this.selectedProducts = null;
        this.messageService.add({
          severity: 'success',
          summary: 'Successful',
          detail: 'Products Deleted',
          life: 3000,
        });
      },
    });
  }

  initReviewApplication(application: Application) {
    this.stateChange.emit({viewSelected: this.viewSelected});
    this.loadingServices.showLoading();
    this.applicationService.getApplicationWithMemberDetails(application.id!).subscribe((res: HttpResponse) => {
      if (res.code === 200) {
        const completeApplication = res.response as Application;
        this.reviewApplication.emit(completeApplication);
      } else {
        this.reviewApplication.emit(application);
      }
      this.loadingServices.hideLoading();
    });
  }

  initReviewTransfer(transfer: Transfer) {
    this.stateChange.emit({viewSelected: this.viewSelected});
    transfer.club = this.getClubById(transfer.applicantClubId);
    this.reviewTransfer.emit(transfer);
  }

  initReviewRenewal(renewal: Renewal) {
    this.stateChange.emit({viewSelected: this.viewSelected});
    this.reviewRenewal.emit(renewal);
  }

  deleteProduct(application: Application) {
    this.confirmationService.confirm({
      message:
        'Are you sure you want to delete ' + application.applicant.name + '?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        //   this.products = this.products.filter((val) => val.id !== product.id);
        //   this.product = {};
        this.messageService.add({
          severity: 'success',
          summary: 'Successful',
          detail: 'Product Deleted',
          life: 3000,
        });
      },
    });
  }

  hideDialog() {
    this.productDialog = false;
    this.submitted = false;
  }

  saveProduct() {
    this.submitted = true;

    //   if (this.product.name?.trim()) {
    //       if (this.product.id) {
    //           this.products[this.findIndexById(this.product.id)] = this.product;
    //           this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'Product Updated', life: 3000 });
    //       } else {
    //           this.product.id = this.createId();
    //           this.product.image = 'product-placeholder.svg';
    //           this.products.push(this.product);
    //           this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'Product Created', life: 3000 });
    //       }

    //       this.products = [...this.products];
    //       this.productDialog = false;
    //       this.product = {};
    //   }
  }

  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.applications.length; i++) {
      if (this.applications[i].id === id) {
        index = i;
        break;
      }
    }

    return index;
  }

  createId(): string {
    let id = '';
    var chars =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (var i = 0; i < 5; i++) {
      id += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return id;
  }

  getSeverity(status: string) {
    switch (status) {
      case 'created':
        return 'PENDIENTE REVISIÓN';
      case 'approved':
        return 'APROBADA';
      case 'responsed':
        return 'RESPUESTA ENVIADA';
      case 'responsed_rejected':
        return 'RESPUESTA RECHAZADA ENVIADA';
      case 'responsed_approved':
        return 'RESPUESTA APROBADA ENVIADA';
      case 'rejected':
        return 'RECHAZADA';
      case 'finished':
        return 'FINALIZADA';
      case 'payment_started':
        return 'En proceso de pago';
      case 'finished_approved':
        return 'Vinculado';
      case 'finished_declined':
        return 'Finalizado pago rechazado';
      case 'finished_error':
        return 'Finalizado error de pago';
      case 'finished_payment_rejected':
        return 'Finalizado pago rechazado';
      case 'accepted_payment_pending':
        return 'Aprobado - Pendiente de Pago';
      case 'finished_payment_error':
        return 'Error en Pago';
      case 'payment_manual_validation':
        return 'Pago en Revisión Manual';
      case 'payment_abandoned':
        return 'Pago Abandonado';

      default:
        return 'Estado Desconocido';
    }
  }

  getRenewalSeverity(status: string) {
    switch (status) {
      case 'accepted_payment_pending':
        return 'Pendiente de Pago';
      case 'payment_started':
        return 'Procesando Pago';
      case 'finished_approved':
        return 'Renovación Completada';
      case 'finished_payment_error':
        return 'Error en Pago';
      case 'finished_error':
        return 'Error en Renovación';
      case 'finished_payment_rejected':
        return 'Pago Rechazado';
      case 'payment_abandoned':
        return 'Pago Abandonado';
      default:
        return 'Estado Desconocido';
    }
  }

  getRenewalAmount(renewal: Renewal): number {
    // Intentar obtener el monto del payment
    if (renewal.payment?.amount) {
      return renewal.payment.amount;
    }

    // Si no está en amount, intentar calcular desde paymentItems
    if (renewal.payment?.paymentItems && renewal.payment.paymentItems.length > 0) {
      return renewal.payment.paymentItems.reduce((sum, item) => sum + (item.valorTotal || 0), 0);
    }

    // Si no hay información de pago, retornar 0
    return 0;
  }

  getHumanTime(time: number) {
    return moment(time).format('DD/MM/yyyy hh:mm:ss a');
  }

  clear(table: Table) {
    table.clear();
  }

  viewRejectedReason(application: Application | Transfer) {
    this.messageService.add({
      severity: 'info',
      summary: 'Comentarios de Rechazo',
      detail: application.comments,
      life: 5000,
    });
  }

  initEditApplication(application: Application) {
    this.editApplication.emit(application);
  }
}
